import { tv } from "../../../../node_modules/.pnpm/tailwind-variants@3.2.2_tailwind-merge@3.3.0_tailwindcss@4.1.8/node_modules/tailwind-variants/dist/index.js";
const systemNavLinkVariants = tv({
  base: "inline-block min-w-27 py-5 px-3 rounded-md transition-[background-color]",
  variants: {
    isSelected: {
      false: "hover:bg-(--tag-1-alpha)",
      true: "bg-(--tag-3-alpha)"
    }
  },
  defaultVariants: {
    isSelected: !1
  }
});
export {
  systemNavLinkVariants
};
//# sourceMappingURL=index.js.map
